import Vue from 'vue';

import HeaderNavigation from './header.vue';
import Hamburger from './hamburger.vue';
import CloseSidebar from './close-sidebar.vue';
import Overlay from './overlay.vue';

import MainNavigation from './megamenu/main-navigation.vue';
import ItemNavigation from './megamenu/item-navigation.vue';
import Megamenu from './megamenu/mega-menu.vue';
import ItemMegamenu from './megamenu/item-megamenu.vue';
import OverlayMegamenu from './megamenu/mega-menu-overlay.vue';
import BackButtonPanel from './megamenu/back-button-panel.vue';

Vue.component(MainNavigation.name, MainNavigation);
Vue.component(ItemNavigation.name, ItemNavigation);
Vue.component(HeaderNavigation.name, HeaderNavigation);
Vue.component(Hamburger.name, Hamburger);
Vue.component(CloseSidebar.name, CloseSidebar);
Vue.component(Overlay.name, Overlay);
Vue.component(Megamenu.name, Megamenu);
Vue.component(ItemMegamenu.name, ItemMegamenu);
Vue.component(OverlayMegamenu.name, OverlayMegamenu);
Vue.component(BackButtonPanel.name, BackButtonPanel);
